<template>
  <div
    id="result"
    class="container h-100"
    :class="{'allowed': canEnter, 'disallowed': !canEnter}"
  >
    <h1 class="text-light font-weight-bold display-3">{{ completed }}</h1>
    <h2 class="text-light font-weight-bolder display-4">{{ displayName }}</h2>
    <h3 class="text-light">{{ email }}</h3>
    <canvas v-show="!canEnter" id="canvas">
    </canvas>
  </div>
</template>

<script>
import { format } from 'date-fns'
export default {
  name: 'Result',
  mounted () {
    // var id = "12345"
    var QRCode = require('qrcode')
    var canvas = document.getElementById('canvas')
    QRCode.toCanvas(canvas, `https://bldg-screen.web.app/admin/${this.surveyId}`, err => {
      if (err) console.error(err)
      console.log('success!')
    })
  },
  computed: {
    completed () {
      if (this.$store.getters.lastSurvey) {
        const dt = new Date(this.$store.getters.lastSurvey.completed)
        return format(dt, "MMM d yyyy")
      }
      return ''
    },
    surveyId () {
      if (this.$store.getters.lastSurvey) {
        return this.$store.getters.lastSurvey.id
      }
      return null
    },
    lastSurvey () {
      if (this.$store.getters.lastSurvey) {
        return this.$store.getters.lastSurvey
      }
      return null
    },
    displayName () {
      return this.$store.getters.displayName
    },
    email () {
      return this.$store.getters.email
    },
    canEnter () {
      if (!this.lastSurvey) {
        return false
      }

      if ('override' in this.lastSurvey && this.lastSurvey['override'] === true) {
        return true
      }

      const answers = this.lastSurvey.answers
      var res = true
      Object.keys(answers).forEach(k => {
        res = res && answers[k] === "No"
      })
      return res
    }
  }
}
</script>

<style scoped>

.allowed {
  background-color: #009900;
}

.disallowed {
  background-color: #990000;
}

</style>